/// <amd-module name="SuiteCommerce.FeaturedCategory.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.FeaturedCategory.Model", ["require", "exports", "Backbone", "SuiteCommerce.FeaturedCategory.Item.Collection", "SuiteCommerce.FeaturedCategory.CCTConfiguration", "SuiteCommerce.FeaturedCategory.Common.Utils"], function (require, exports, Backbone_1, Item_Collection_1, FeaturedCategory_Configuration_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CCTFields;
    (function (CCTFields) {
        CCTFields["showName"] = "custrecord_cct_ns_featcatcct_showname";
        CCTFields["desktopQty"] = "custrecord_cct_ns_featcatcct_desktopqty";
        CCTFields["headerLink"] = "custrecord_cct_ns_featcatcct_headerlink";
        CCTFields["sort"] = "custrecord_cct_ns_featcatcct_sort";
        CCTFields["mobileItems"] = "custrecord_cct_ns_featcatcct_mobileitems";
        CCTFields["showPrice"] = "custrecord_cct_ns_featcatcct_showprice";
        CCTFields["buttonStyle"] = "custrecord_cct_ns_featcatcct_buttonstyle";
        CCTFields["buttonText"] = "custrecord_cct_ns_featcatcct_buttontext";
        CCTFields["customUrl"] = "custrecord_cct_ns_featcatcct_customurl";
        CCTFields["columns"] = "custrecord_cct_ns_featcatcct_columns";
        CCTFields["mobileCol"] = "custrecord_cct_ns_featcatcct_mobilecol";
        CCTFields["categoryId"] = "custrecord_cct_ns_featcatcct_categoryid";
        CCTFields["category"] = "custrecord_cct_ns_featcatcct_category";
        CCTFields["header"] = "custrecord_cct_ns_featcatcct_header";
        CCTFields["headerAlign"] = "custrecord_cct_ns_featcatcct_headeralign";
    })(CCTFields = exports.CCTFields || (exports.CCTFields = {}));
    var FeaturedCategoryModel = /** @class */ (function (_super) {
        __extends(FeaturedCategoryModel, _super);
        function FeaturedCategoryModel(options) {
            var _this = _super.call(this, options) || this;
            if (options) {
                _this.environment = options.container.getComponent('Environment');
            }
            return _this;
        }
        Object.defineProperty(FeaturedCategoryModel.prototype, "urlRoot", {
            get: function () {
                var urlRoot;
                urlRoot = Utils_1.Utils.getAbsoluteUrl(getExtensionAssetsPath('services/FeaturedCategory.Service.ss'));
                if (this.categoryId) {
                    urlRoot = Utils_1.Utils.addParamsToUrl(urlRoot, {
                        categoryId: this.categoryId,
                    });
                }
                return urlRoot;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "fullUrl", {
            get: function () {
                return this.get('fullurl');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "name", {
            get: function () {
                return this.get('name') || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "categoryId", {
            get: function () {
                return this.get(CCTFields.category) || this.get(CCTFields.categoryId);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "headerText", {
            get: function () {
                return this.get(CCTFields.header) || '';
            },
            set: function (headerText) {
                this.set(CCTFields.header, headerText);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "customUrl", {
            get: function () {
                return this.get(CCTFields.customUrl);
            },
            set: function (url) {
                this.set(CCTFields.customUrl, url);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "headerPosition", {
            get: function () {
                var headerAlign = this.get(CCTFields.headerAlign);
                return headerAlign ? FeaturedCategory_Configuration_1.CCTConfiguration.getHeaderPosition(headerAlign) : '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "hasHeader", {
            get: function () {
                return !!this.headerText;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "headerAllowLink", {
            get: function () {
                return this.get(CCTFields.headerLink) === 'T';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "showItemPrice", {
            get: function () {
                return this.get(CCTFields.showPrice) === 'T';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "showItemName", {
            get: function () {
                return this.get(CCTFields.showName) === 'T';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "buttonText", {
            get: function () {
                return this.get(CCTFields.buttonText);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "buttonStyle", {
            get: function () {
                var buttonStyle = this.get(CCTFields.buttonStyle);
                return buttonStyle ? FeaturedCategory_Configuration_1.CCTConfiguration.getButtonStyle(buttonStyle) : '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "itemSorting", {
            get: function () {
                var sort = this.get(CCTFields.sort);
                if (sort) {
                    return FeaturedCategory_Configuration_1.CCTConfiguration.getSortField(sort);
                }
                return;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "colsPerRow", {
            get: function () {
                return FeaturedCategory_Configuration_1.CCTConfiguration.getColumnsPerRow(this.get(CCTFields.columns));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "colsPerRowPhone", {
            get: function () {
                return FeaturedCategory_Configuration_1.CCTConfiguration.getColumnsPerRowPhone(this.get(CCTFields.mobileCol));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "items", {
            get: function () {
                if (!this.get('items')) {
                    this.items = new Item_Collection_1.ItemCollection(null, {
                        environment: this.environment
                    });
                }
                return this.get('items');
            },
            set: function (items) {
                this.set('items', items);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "headerIsHtml", {
            get: function () {
                return this.isHTML(this.headerText);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FeaturedCategoryModel.prototype, "numberOfItems", {
            get: function () {
                var numberOfItems = FeaturedCategory_Configuration_1.CCTConfiguration.getNumberOfItems(this.get(CCTFields.desktopQty), '6');
                if (jQuery(window).width() < 768) {
                    numberOfItems = FeaturedCategory_Configuration_1.CCTConfiguration.getNumberOfItems(this.get(CCTFields.mobileItems), '2');
                }
                return numberOfItems;
            },
            enumerable: true,
            configurable: true
        });
        FeaturedCategoryModel.prototype.addProperties = function (properties) {
            this.set(properties);
        };
        FeaturedCategoryModel.prototype.isHTML = function (stringToCheck) {
            var divWrapper = document.createElement('div');
            var childNodes;
            var parsedHtml;
            divWrapper.innerHTML = stringToCheck;
            childNodes = divWrapper.childNodes;
            if (childNodes.length > 0) {
                parsedHtml = this.htmlDecode(this.headerText);
                this.headerText = parsedHtml;
                return true;
            }
            return false;
        };
        FeaturedCategoryModel.prototype.htmlDecode = function (input) {
            var e = document.createElement('textarea');
            e.innerHTML = input;
            return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
        };
        return FeaturedCategoryModel;
    }(Backbone_1.Model));
    exports.FeaturedCategoryModel = FeaturedCategoryModel;
});
